module.exports = __webpack_public_path__ + "img/2024-10-16c_2.b91d49c2.jpg";